import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const formatNumber = (num) => {
    return new Intl.NumberFormat("id-ID").format(num);
};

function SubConPdfGenerator ({ vendorData }) {
    const itemsData = [
        { type: 'JASA', description: `${vendorData.clientName}`, total: `Rp${formatNumber(vendorData.termin1)}`, pph:`Rp${formatNumber(vendorData.pph)}`, subTotal:`Rp${formatNumber(vendorData.subTotal)}` },
    ];

    const pdf = new jsPDF({
        unit: "mm", 
        format: "a4"
    });

    pdf.setProperties({
        title: "Invoice SubCon"
    });

    pdf.setFontSize(17);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor(150, 150, 150);
    pdf.text('INVOICE', 28, 36);

    pdf.setDrawColor(150, 150, 150)
    pdf.setLineWidth(2);
    pdf.line(28, 42, 28 + 150, 42);

    pdf.setFontSize(9);
    pdf.setTextColor(0, 0, 0);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Project', 28, 50);
    pdf.text(':', 49, 50);
    pdf.text(`${vendorData.clientName} - ${vendorData.projectLocation}`, 51, 50);
    pdf.text('Kontraktor', 28, 55);
    pdf.text(':', 49, 55);
    pdf.text(vendorData.subConName, 51, 55);
    pdf.text('Keterangan', 28, 60);
    pdf.text(':', 49, 60);
    pdf.text(vendorData.typeName, 51, 60);
    
    let itemDetailsRows = itemsData?.map((item, index) => [
        item.type.toString(),
        item.description.toString(),
        item.total.toString(),
        item.pph.toString(),
        item.subTotal.toString(),
    ]);
    let itemDetailsHeaders = ['JENIS', 'NAMA CLIENT', 'TOTAL', 'PPH' ,'SUB TOTAL'];
    // let columnWidths = [20, 45, 40, 30, 30];
    let columnWidths = [20, 40, 30, 30, 30];


    let itemDetailsYStart = 70;

    autoTable(pdf, {
        head: [itemDetailsHeaders],
        body: itemDetailsRows,
        startY: itemDetailsYStart,
        theme: 'grid',
        styles: {
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
            cellPadding: 0, // Reduce spacing inside cells
            fontSize: 9, 
            textColor: [0, 0, 0], // Black text
        }, 
        headStyles: {
            fillColor: [160, 160, 160],
            textColor: [255, 255, 255],
            lineColor: [0, 0, 0],
            fontStyle: "bold",
            fontSize: 10,
            font: "helvetica",
            halign: "center",
            lineWidth: 0.5,
            cellPadding: { top: 1, bottom: 1, left: 0 }
        },
        columnStyles: {
            0: { cellWidth: columnWidths[0], halign: "center" },
            1: { cellWidth: columnWidths[1], halign: "left" },
            2: { cellWidth: columnWidths[2], halign: "right" },
            3: { cellWidth: columnWidths[3], halign: "right" },
            4: { cellWidth: columnWidths[4], halign: "right" },
        },
        bodyStyles: {
            fontSize: 9.5,
            font: "helvetica",
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            lineWidth: 0.5,
            cellPadding: { top: 2, right: 2, bottom: 1, left: 2 },
        },
        alternateRowStyles: { fillColor: [255, 255, 255] },
        didDrawCell: (data) => {
            
        },
        didParseCell: function (data) {
           
        },
        styles: { rowPageBreak: "avoid" },
        margin: { top: 10, left: 28 },
    
    });

    // Add summary and page numbers
    const summaryYStart = pdf.lastAutoTable.finalY + 10;

    pdf.setFont('helvetica', 'bold');
    pdf.text('Seluruh pembayaran dibayarkan ke rekening :', 28, summaryYStart);

    pdf.text('Hormat kami', 155, summaryYStart + 5);

    pdf.text('Nama Bank', 28, summaryYStart + 5);
    pdf.text(': ', 56, summaryYStart + 5);
    pdf.text(`Bank ${vendorData.bankName}`, 58, summaryYStart + 5);

    pdf.text('No. Rekening', 28, summaryYStart + 10);
    pdf.text(': ', 56, summaryYStart + 10);
    pdf.text(`${vendorData.accountNumber}`, 58, summaryYStart + 10);

    pdf.text('Atas Nama', 28, summaryYStart + 15);
    pdf.text(': ', 56, summaryYStart + 15);
    pdf.text(vendorData.subConName, 58, summaryYStart + 15);
    pdf.text(vendorData.subConName, 155, summaryYStart + 40);

    pdf.addPage();

    pdf.setFontSize(17);
    pdf.setFont('helvetica', 'normal');
    pdf.setTextColor(150, 150, 150);
    pdf.text('INVOICE', 50, 36);

    pdf.setDrawColor(150, 150, 150)
    pdf.setLineWidth(2);
    pdf.line(50, 42, 50 + 100, 42);
    pdf.setFontSize(9);
    pdf.setTextColor(0, 0, 0);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Project', 50, 50);
    pdf.text(':', 71, 50);
    pdf.text(`${vendorData.clientName} - ${vendorData.projectLocation}`, 73, 50);
    pdf.text('Kontraktor', 50, 55);
    pdf.text(':', 71, 55);
    pdf.text(vendorData.subConName, 73, 55);
    pdf.text('Keterangan', 50, 60);
    pdf.text(':', 71, 60);
    pdf.text(vendorData.typeName, 73, 60);
    
    const itemsDetail = [
        { type:'MATERIAL', description: `${vendorData.clientName}`, total: `Rp${formatNumber(vendorData.material)}` },
    ];
    itemDetailsRows = itemsDetail?.map((item, index) => [
        item.type.toString(),
        item.description.toString(),
        item.total.toString(),
      
    ]);
    itemDetailsHeaders = ['JASA', 'DESKRIPSI', 'TOTAL'];
    columnWidths = [20,35, 45];

    itemDetailsYStart = 70;

    autoTable(pdf, {
        head: [itemDetailsHeaders],
        body: itemDetailsRows,
        startY: itemDetailsYStart,
        theme: 'grid',
        styles: {
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
            cellPadding: 0, // Reduce spacing inside cells
            fontSize: 10, 
            textColor: [0, 0, 0], // Black text
        }, 
        headStyles: {
            fillColor: [160, 160, 160],
            textColor: [255, 255, 255],
            lineColor: [0, 0, 0],
            fontStyle: "bold",
            fontSize: 9.5,
            font: "helvetica",
            halign: "center",
            lineWidth: 0.5,
            cellPadding: { top: 1, bottom: 1, left: 0 }
        },
        columnStyles: {
            0: { cellWidth: columnWidths[0], halign: "center" },
            1: { cellWidth: columnWidths[1], halign: "center" },
            2: { cellWidth: columnWidths[2], halign: "right" },
        },
        bodyStyles: {
            fontSize: 9.5,
            font: "helvetica",
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            lineWidth: 0.5,
            cellPadding: { top: 2, right: 2, bottom: 1, left: 2 },
        },
        alternateRowStyles: { fillColor: [255, 255, 255] },
        didDrawCell: (data) => {
            
        },
        didParseCell: function (data) {
           
        },
        styles: { rowPageBreak: "avoid" },
        margin: { top: 10, left: 50 },
    
    });

    pdf.setFont('helvetica', 'bold');
    pdf.text('Seluruh pembayaran dibayarkan ke rekening :', 50, summaryYStart);

    pdf.text('Hormat kami', 131, summaryYStart + 20);

    pdf.text('Nama Bank', 50, summaryYStart + 5);
    pdf.text(': ', 78, summaryYStart + 5);
    pdf.text(`Bank ${vendorData.bankName2}`, 80, summaryYStart + 5);

    pdf.text('No. Rekening', 50, summaryYStart + 10);
    pdf.text(': ', 78, summaryYStart + 10);
    pdf.text(`${vendorData.accountNumber2}`, 80, summaryYStart + 10);

    pdf.text('Atas Nama', 50, summaryYStart + 15);
    pdf.text(': ', 78, summaryYStart + 15);
    pdf.text(vendorData.subConName, 80, summaryYStart + 15);

    pdf.text(vendorData.subConName, 131, summaryYStart + 50);

    const pdfDataUri = pdf.output('datauristring');

    const link = document.createElement('a');
    link.href = pdfDataUri;
    link.download = 'RFQ.pdf';
    link.click();

    const newTab = window.open();
    newTab?.document.write(`<iframe width='100%' height='100%' src='${pdfDataUri}'></iframe>`);
}

export default SubConPdfGenerator